import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  CampaignControllerDtoResourceUpdateRequest,
  PerplayCampaignApi,
} from '../../models/src';
import BaseResponse from '../../models/src/model/BaseResponse';
import { UPLOAD_RESOURCES_REQUEST } from '../../constants/app/resourceFetchConstants';

const api = new PerplayCampaignApi(config.API_CLIENT);

function* uploadResourcesSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoResourceUpdateRequest();
    requestData.resources = payload.resources;
    const res = yield api.apiPerplayCampaignResourceUpdatePost(
      { campaignControllerDtoResourceUpdateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* rootSaga() {
  yield all([takeEvery(UPLOAD_RESOURCES_REQUEST, uploadResourcesSaga)]);
}

const resourceFetchSagas = [fork(rootSaga)];
export default resourceFetchSagas;
